import { PropsWithChildren } from 'react';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';

// ----------------------------------------------------------------------

interface DisplayInlineErrorProps extends PropsWithChildren<{}> {
    error: Error | null | undefined;
    processError?: (error: Error) => string | null | undefined;
    severity?: 'error' | 'warning' | 'info' | 'success';
}

export const DisplayInlineError = ({
    error,
    children,
    processError,
    severity = 'error',
}: DisplayInlineErrorProps) => {
    const processed = processError && error ? processError(error) : undefined
    const errorMessage = processed || error?.message || ''
    return (
        <Collapse in={!!error}>
            <Alert severity={severity}>
                {children}
                <Typography sx={{ mt: children ? 1 : 0 }}>
                    {errorMessage}
                </Typography>
            </Alert>
        </Collapse>
    );
};

